import portfolioPhoto from '../../api/portfolio-photo'
import classOperation from '@/api/class-operation'
import Enrollment from '@/api/student-enrollment'
import { baseState, baseMutations } from '@/store/mixins'
import year from '@/api/academic-year'
import term from '@/api/term-semester'
import moment from 'moment'

export const state = {
	...baseState,
	ac_status_id: 1,
	ac_year_id: undefined,
	portfolio_type_id: undefined,
	date_from: moment()
		.add(-1, 'Month')
		.format('DD-MM-YYYY'),
	date_to: moment()
		.format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_DATE_FROM(state, data) {
		state.date_from = data
	},
	SET_DATE_TO(state, data) {
		state.date_to = data
	},
	SET_YEAR_ID(state, data) {
		state.ac_year_id = data
	},
	SET_PORTFOLIO_ID(state, data) {
		state.portfolio_type_id = data
	},
	SET_AC_STATUS(state, acStatusId) {
		state.ac_status_id = acStatusId
	}
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				search: context.state.search,
				ac_year_id: context.state.ac_year_id,
				portfolio_type_id: context.state.portfolio_type_id,
				date_range: [context.state.date_from, context.state.date_to]
			},
			attrubutes
		)
		return portfolioPhoto.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return portfolioPhoto.store(data)
	},
	//download specify photo
	download(context, id) {
		return portfolioPhoto.download(id)
	},
	//delete specify photo
	removePhoto(context, id) {
		return portfolioPhoto.removePhoto(id)
	},
	removeFileUploaded(context, attributes) {
		return portfolioPhoto.removeFile({
			params: attributes
		})
	},
	update(context, data) {
		return portfolioPhoto.update(data)
	},
	destroy(context, id) {
		return portfolioPhoto.destroy(id)
	},
	// Get Student Enrollment by Class
	getStudentEnrollmentByClass(context, attributes) {
		return Enrollment.get({
			params: {
				include: 'student_profile',
				fields: {
					academic_student_to_classes: 'class_id,student_id,teacher_resp_id',
					student_profile: 'student_id,card_number,first_name_en,last_name_en,branch_id'
				},
				filter: {
					branch_id: attributes.branch_id,
					class_id: attributes.class_id
				},
				page: -1
			}
		})
	},
	getClassOperation(context, attributes) {
		return classOperation.get({
			params: {
				include: 'academic_year,academic_term,teacher',
				fields: {
					academic_classes: 'class_id,class_name,ac_year_id,ac_term_id,teacher_resp_id,class_desc,branch_id',
					academic_term: 'ac_term_id,term_name,term_order',
					academic_year: 'ac_year_id,ac_year',
					teacher: 'teacher_id,fname_foreign,lname_foreign'
				},
				filter: {
					ac_status_id: context.state.ac_status_id,
					branch_id: attributes.branch_id,
					ac_term_id: attributes.ac_term_id
				},
				page: -1
			},
			header: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	},
	getYear(context, attributes = {}) {
		return year.get({
			params: Object.assign(
				{
					fields: {
						academic_years: 'ac_year_id,ac_year,ac_status_id'
					},
					page: -1
				},
				attributes
			),
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	},
	getTerm(context, attributes = {}) {
		return term.get({
			params: Object.assign(
				{
					fields: {
						academic_terms: 'ac_term_id,term_name,ac_status_id'
					},
					filter: {
						ac_year_id: attributes
					},
					page: -1
				},
				attributes
			),
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	},
	getPortfolio(context, data) {
		return portfolioPhoto.portfolioType(data)
	},
	releasePortfolio(context, upload_id_list) {
		return portfolioPhoto.releasePortfolio({ upload_id_list: upload_id_list })
	},
	previewListPortfolio(context, data) {
		return portfolioPhoto.previewListPortfolio(Object.assign({
			date_from: context.state.date_from,
			date_to: context.state.date_to,
			portfolio_type_id: data.portfolio_type_id,
			ac_term_id: data.term_id,
			ac_year_id: data.ac_year_id,
			class_id: data.class_id,
			student_id: data.student_id
		}), data)
	}
}
